import React, { useState, useEffect } from 'react';
import './SimpleDiceRoll.css';

// The six symbols used in the game, matching the main game file
const symbols = ['heart', 'crown', 'spade', 'diamond', 'flag', 'club'];

/**
 * A simple 2D dice component that displays animated dice cards.
 * Used as an alternative to the 3D physics-based DiceScene.
 * @param {object} props - The component's props.
 * @param {string[]} props.results - Array of 6 symbol results to display.
 * @param {boolean} props.isRolling - Whether the dice are currently rolling/animating.
 */
function SimpleDiceRoll({ results, isRolling }) {
    // Shuffling symbols shown during the roll animation
    const [shuffleSymbols, setShuffleSymbols] = useState(Array(6).fill(null));

    // Rapidly shuffle the visible symbols during the rolling animation
    useEffect(() => {
        if (!isRolling) return;

        const shuffleInterval = setInterval(() => {
            setShuffleSymbols(
                Array(6).fill(null).map(() => symbols[Math.floor(Math.random() * symbols.length)])
            );
        }, 100); // Shuffle every 100ms for a rapid animation effect

        return () => clearInterval(shuffleInterval);
    }, [isRolling]);

    // Determine which symbols to display: shuffling symbols during roll, actual results after
    const displaySymbols = isRolling ? shuffleSymbols : results;

    return (
        <div className="simple-dice-container">
            <div className="simple-dice-grid">
                {displaySymbols.map((symbol, index) => (
                    <div
                        key={index}
                        className={`simple-die ${isRolling ? 'rolling' : ''} ${symbol ? 'revealed' : 'empty'}`}
                    >
                        {symbol ? (
                            <div className="simple-die-face">
                                <img
                                    src={`./assets/${symbol}.png`}
                                    alt={symbol}
                                    className="simple-die-icon"
                                />
                                <span className="simple-die-label">
                                    {symbol.charAt(0).toUpperCase() + symbol.slice(1)}
                                </span>
                            </div>
                        ) : (
                            <div className="simple-die-face empty-face">
                                <span className="question-mark">?</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {/* Instructional text when no results yet */}
            {!isRolling && !results.some(r => r !== null) && (
                <p className="simple-dice-hint">Place your bets and roll the dice!</p>
            )}
        </div>
    );
}

export default SimpleDiceRoll;
